import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-competition-details-skeleton',
  standalone: true,
  imports: [],
  templateUrl: './competition-details-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompetitionDetailsSkeletonComponent {}
